/**
 * ChannelListInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

/**
 * Styled channel list info container.
 */
const ChannelListInfoContainer = styled.div<{ focused?: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: ${120 * Screen.widthRatio}px;
  left: ${520 * Screen.widthRatio}px;
  height: ${920 * Screen.widthRatio}px;
  width: ${(props) => (props.focused ? 1180 : 1050) * Screen.widthRatio}px;
  transition: ${TRANSITION.CHANNEL_LIST_INFO};
`;

export default ChannelListInfoContainer;
